import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";
import type { Theme } from "../../../types/Theme";

export default createUseStyles({
    numericRanking: {
        composes: "numericRanking",
    },
    numericOptionList: {
        composes: "numeric-option-list",
    },
    numericOption: {
        composes: "numeric-option",
    },
    numericOptionChoiceTextHeader: {
        composes: "numeric-option__choice-text-header",
    },
    numericOptionChoiceRankingHeader: {
        composes: "numeric-option__choice-ranking-header",
    },
    numericOptionChoiceHeader: ({ theme }: { theme: Theme }) => ({
        composes: "numeric-option__choice-header",
        paddingBottom: theme.NumericRankingRowPaddingY,
        paddingTop: theme.NumericRankingRowPaddingY,
    }),
    numericOptionChoiceText: ({ theme }: { theme: Theme }) => ({
        composes: "numeric-option__choice-text",
        paddingBottom: theme.NumericRankingRowPaddingY,
        paddingRight: theme.NumericRankingInputTextGap,
        paddingTop: theme.NumericRankingTextPaddingTop,
        verticalAlign: "middle",
    }),
    numericOptionChoiceRanking: ({ theme }: { theme: Theme }) => ({
        composes: "numeric-option__choice-ranking",
        paddingRight: theme.NumericRankingInputTextGap,
        verticalAlign: "middle",
    }),
    numericOptionChoiceInput: {
        composes: "numeric-option__choice-Input",
        verticalAlign: "middle",
    },
    numericOptionChoiceLabel: {
        composes: "numeric-option__choice-label",
    },
    numericOptionChoiceSelected: ({ theme }) => ({
        background: theme.PrimaryColor,
        color: Mixins.foregroundColor(theme, theme.PrimaryColor),
        composes: "numeric-option__choice-ranking--selected",
    }),
});
